export const POS_SESSION_KEYS = {
  COUNTER: 'saaspos_selected_counter_id',
  TERMINAL: 'saaspos_selected_terminal_id',
  SHIFT: 'saaspos_active_shift_id',
} as const;

export function clearPosSessionStorage(): void {
  sessionStorage.removeItem(POS_SESSION_KEYS.COUNTER);
  sessionStorage.removeItem(POS_SESSION_KEYS.TERMINAL);
  sessionStorage.removeItem(POS_SESSION_KEYS.SHIFT);
}
